import { Component, OnInit } from '@angular/core';
import {PaymentMethodsService} from '../../services/payment-methods.service'
import { AuthService } from 'src/app/services/auth.service';
import {MessageService} from 'primeng/api';
import { CommonService } from 'src/app/services/common.service';
declare var MachnetWidget: any;

@Component({
  selector: 'app-manage-payment-methods',
  templateUrl: './manage-payment-methods.component.html',
  styleUrls: ['./manage-payment-methods.component.scss']
})
export class ManagePaymentMethodsComponent implements OnInit {
  bankMethods=[]
  cardMethods=[]
  all=[]
  token = ''
  bankShown : boolean
  constructor(public paymentMethodService:PaymentMethodsService, public auth:AuthService,private messageService: MessageService,public common:CommonService) { }

  ngOnInit(): void {
    this.getPaymentMethods()
    this.common.showLoader()
    this.auth.getWidgetToken().subscribe((res:any)=>{
      //console.log(res)
      this.token = res.token;
      this.common.stopLoader()
    },err=>{
      let errorKeys = Object.keys(err.error.errors); 
      errorKeys.forEach(key => { 
        //console.log(key)
        let value = err.error.errors[key][0]; 
        this.messageService.add({severity:'error', summary:value, detail:""});
        //console.log(value); 
    }); 
      //console.log(err)
      this.common.stopLoader()
    })
  }

  getPaymentMethods(){
    this.common.showLoader()
    this.paymentMethodService.getFundingSource().subscribe((res:any)=>{
      //console.log(res)
      this.all=res.results
      this.bankMethods = this.all.filter(element=>{
        return element.funding_source_type == "BANK"
      })
      this.cardMethods = this.all.filter(element=>{
        return element.funding_source_type == "CARD"
      })
      //console.log(this.bankMethods)
      //console.log(this.cardMethods)
      this.common.stopLoader()
    },err=>{
      let errorKeys = Object.keys(err.error.errors); 
      errorKeys.forEach(key => { 
        //console.log(key)
        let value = err.error.errors[key][0]; 
        this.messageService.add({severity:'error', summary:value, detail:""});
        //console.log(value); 
    }); 
      //console.log(err)
      this.common.stopLoader()
    })
  }

  addScript(senderid,token,type){
    
    var widget = new MachnetWidget({
      elementId: "widget-root-type",
      senderId: senderid,
      width: "100%",
      height: "800px",
      fontSize:"14px",
      type: type,
      locale: "en",
      multiStep: true,
      stylesheet: "../../styles.scss",
      token: token,
    });
    widget.init();
    window.addEventListener("message", function (e) {
      //console.log("type", e.data.type)
      //console.log("all_detail", e.data)
      //console.log("all", e)
      if(e.data.status == "CARD_ADDED"){
        this.bankShown=false
        this.getPaymentMethods()
        // this.messageService.add({severity:'success', summary:'Payment Method Is Added', detail:""});
      }
      if(e.data.status == "BANK_ADDED"){
        this.bankShown=false
        this.getPaymentMethods()
        // this.messageService.add({severity:'success', summary:'Payment Method Is Added', detail:""});
      }
     
    }.bind(this));
  }

  onAddBank() {
    this.bankShown = true;
    this.addScript(this.auth.user.uuid,this.token, 'bank')
  }
  onAddCard() {
    this.bankShown = true
    this.addScript(this.auth.user.uuid,this.token, 'card')
    
  }

  close(){
    this.bankShown=false;
    this.getPaymentMethods()
  }
}
